import { gql } from '@apollo/client'

export const ADMIN_STORE_FRAGMENT_WITH_POG = gql`
  fragment AdminStoreWithPOG on CompanyStore {
    id
    totalAudits
    distance
    physicalStoreId
    storeChain
    name
    internalStoreId
    category
    isActive
    allOptimizingPaused
    optimizingPausedAt
    resumeOptimizingAt
    numTimesOptimizeHighPerYear
    numTimesOptimizeMediumPerYear
    numTimesOptimizeLowPerYear
    avgPlanogramComplianceScore
    image {
      id
      url
    }
    address {
      address1
      address2
      city
      state
      postalCode
    }
    point {
      latitude
      longitude
    }
    lastAudit
    daysSinceAudit
    region {
      name
    }
  }
`
